var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 50,
    viewBox: "0 0 173 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.14 50H7.05736C3.57649 50 0.740234 47.1967 0.740234 43.7563V6.26911C0.740234 2.82874 3.57649 0.0254822 7.05736 0.0254822H165.14C168.622 0.0254822 171.457 2.82874 171.457 6.26911V43.7563C171.457 47.1967 168.596 50 165.14 50Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.14 0.996691C168.08 0.996691 170.452 3.34124 170.452 6.24643V43.7336C170.452 46.6389 168.08 48.9835 165.14 48.9835H7.05736C4.11796 48.9835 1.74583 46.6389 1.74583 43.7336V6.24643C1.74583 3.34124 4.11796 0.996691 7.05736 0.996691H165.14ZM165.14 0.00280762H7.05736C3.5765 0.00280762 0.740234 2.80607 0.740234 6.24643V43.7336C0.740234 47.1741 3.5765 49.9773 7.05736 49.9773H165.14C168.621 49.9773 171.457 47.1741 171.457 43.7336V6.24643C171.457 2.80607 168.596 0.00280762 165.14 0.00280762Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.693 12.8187C60.693 13.8636 60.3836 14.7046 59.7648 15.3162C59.0428 16.0552 58.1146 16.4374 56.9802 16.4374C55.8972 16.4374 54.9432 16.0552 54.1954 15.3162C53.4219 14.5516 53.0352 13.6342 53.0352 12.5129C53.0352 11.3916 53.4219 10.4741 54.1954 9.73509C54.9689 8.99607 55.8972 8.6138 56.9802 8.6138C57.5216 8.6138 58.0373 8.71573 58.5272 8.9196C59.017 9.12348 59.4296 9.40384 59.7133 9.76062L59.0428 10.4232C58.5272 9.83705 57.8568 9.53125 56.9544 9.53125C56.155 9.53125 55.4588 9.81151 54.8916 10.3722C54.2985 10.9329 54.015 11.6464 54.015 12.5384C54.015 13.4304 54.2985 14.1438 54.8916 14.7046C55.4846 15.2652 56.1808 15.5455 56.9544 15.5455C57.8052 15.5455 58.5014 15.2652 59.0686 14.7046C59.4296 14.3478 59.6617 13.838 59.7133 13.1754H56.9544V12.2836H60.6157C60.693 12.4364 60.693 12.6148 60.693 12.8187Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5238 9.68403H63.0687V12.054H66.1886V12.946H63.0687V15.3161H66.5238V16.2335H62.0889V8.74112H66.5238C66.5238 8.7666 66.5238 9.68403 66.5238 9.68403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.641 16.2587H69.6612V9.68383H67.5469V8.76639H72.7553V9.68383H70.641V16.2587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5215 16.2587V8.76639H77.5012V16.2587H76.5215Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8334 16.2587H80.8536V9.68383H78.7393V8.76639H83.9477V9.68383H81.8334V16.2587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8245 15.2904C93.0772 16.0549 92.1486 16.4372 91.0397 16.4372C89.9308 16.4372 89.0029 16.0549 88.2552 15.2904C87.5075 14.5259 87.1465 13.6085 87.1465 12.5127C87.1465 11.4168 87.5075 10.4739 88.2552 9.7349C89.0029 8.97035 89.9308 8.58807 91.0397 8.58807C92.1486 8.58807 93.0772 8.97035 93.8245 9.7349C94.5727 10.4994 94.9594 11.4168 94.9594 12.5127C94.9335 13.6085 94.5727 14.5259 93.8245 15.2904ZM88.9772 14.6533C89.5442 15.2139 90.2147 15.4943 91.0397 15.4943C91.8388 15.4943 92.5352 15.2139 93.1022 14.6533C93.6701 14.0927 93.9531 13.3791 93.9531 12.4871C93.9531 11.5952 93.6701 10.8817 93.1022 10.321C92.5352 9.76035 91.8647 9.47999 91.0397 9.47999C90.2147 9.47999 89.5442 9.76035 88.9772 10.321C88.4099 10.8817 88.1263 11.5952 88.1263 12.4871C88.1263 13.3791 88.4099 14.0927 88.9772 14.6533Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2969 16.2587V8.76639H97.4835L101.17 14.6023H101.222L101.17 13.1496V8.76639H102.15V16.2587H101.144L97.2772 10.1426H97.2254L97.2772 11.5952V16.2587H96.2969Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199309,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8931 27.1916C83.9279 27.1916 81.5042 29.4342 81.5042 32.5178C81.5042 35.5759 83.9279 37.8439 86.8931 37.8439C89.8585 37.8439 92.3076 35.5759 92.3076 32.5178C92.3076 29.4342 89.8844 27.1916 86.8931 27.1916ZM86.8931 35.7288C85.2687 35.7288 83.8506 34.4036 83.8506 32.5178C83.8506 30.6064 85.2429 29.3068 86.8931 29.3068C88.5433 29.3068 89.9353 30.6064 89.9353 32.5178C89.9353 34.4036 88.5175 35.7288 86.8931 35.7288ZM75.1355 27.1916C72.1704 27.1916 69.7466 29.4342 69.7466 32.5178C69.7466 35.5759 72.1704 37.8439 75.1355 37.8439C78.1007 37.8439 80.5245 35.5759 80.5245 32.5178C80.5245 29.4342 78.1007 27.1916 75.1355 27.1916ZM75.1355 35.7288C73.5112 35.7288 72.093 34.4036 72.093 32.5178C72.093 30.6064 73.5112 29.3068 75.1355 29.3068C76.7599 29.3068 78.178 30.6064 78.178 32.5178C78.1523 34.4036 76.7599 35.7288 75.1355 35.7288ZM61.1089 28.8226V31.0906H66.5752C66.4204 32.3649 65.9821 33.2823 65.3375 33.9194C64.5382 34.7094 63.3006 35.5759 61.1089 35.5759C57.757 35.5759 55.127 32.9 55.127 29.5871C55.127 26.2741 57.757 23.5983 61.1089 23.5983C62.9138 23.5983 64.2546 24.3119 65.2344 25.2038L66.833 23.6237C65.4664 22.3241 63.6616 21.3557 61.1089 21.3557C56.4936 21.3557 52.626 25.0509 52.626 29.6126C52.626 34.1743 56.4936 37.8695 61.1089 37.8695C63.61 37.8695 65.4664 37.0539 66.9362 35.5504C68.4316 34.0723 68.9215 31.9571 68.9215 30.2752C68.9215 29.74 68.87 29.2558 68.7926 28.8736C68.7926 28.8226 61.1089 28.8226 61.1089 28.8226ZM118.401 30.581C117.963 29.3832 116.597 27.1916 113.786 27.1916C111.027 27.1916 108.707 29.3578 108.707 32.5178C108.707 35.4995 110.975 37.8439 114.044 37.8439C116.519 37.8439 117.937 36.3659 118.53 35.4995L116.7 34.3017C116.081 35.1936 115.256 35.7797 114.044 35.7797C112.858 35.7797 111.981 35.2446 111.44 34.1743L118.633 31.2436C118.659 31.1671 118.401 30.581 118.401 30.581ZM111.079 32.3394C111.027 30.3006 112.677 29.2304 113.889 29.2304C114.817 29.2304 115.617 29.689 115.9 30.3516C115.875 30.3771 111.079 32.3394 111.079 32.3394ZM105.225 37.5127H107.598V21.8909H105.225V37.5127ZM101.358 28.3638H101.281C100.739 27.7522 99.7335 27.1916 98.4442 27.1916C95.7629 27.1916 93.2879 29.5362 93.2879 32.5178C93.2879 35.4995 95.7629 37.8185 98.4442 37.8185C99.7335 37.8185 100.739 37.2579 101.281 36.6207H101.358V37.3853C101.358 39.424 100.25 40.5198 98.496 40.5198C97.0522 40.5198 96.1495 39.5004 95.7888 38.634L93.7263 39.4749C94.3192 40.8766 95.8915 42.6096 98.496 42.6096C101.281 42.6096 103.601 41.004 103.601 37.0795V27.5229H101.358V28.3638ZM98.6504 35.7288C97.0263 35.7288 95.6594 34.3781 95.6594 32.5178C95.6594 30.632 97.0263 29.2812 98.6504 29.2812C100.25 29.2812 101.513 30.6574 101.513 32.5178C101.513 34.3781 100.25 35.7288 98.6504 35.7288ZM129.489 21.8654H123.842V37.4872H126.188V31.5748H129.489C132.118 31.5748 134.671 29.689 134.671 26.7329C134.671 23.7512 132.092 21.8654 129.489 21.8654ZM129.541 29.4087H126.188V24.0571H129.541C131.293 24.0571 132.299 25.5096 132.299 26.7329C132.299 27.9306 131.293 29.4087 129.541 29.4087ZM144.134 27.1661C142.433 27.1661 140.653 27.9051 139.931 29.5616L142.02 30.428C142.458 29.5616 143.309 29.2812 144.185 29.2812C145.398 29.2812 146.661 30.0204 146.661 31.2946V31.4474C146.223 31.1926 145.32 30.8358 144.185 30.8358C141.942 30.8358 139.622 32.059 139.622 34.3527C139.622 36.4423 141.478 37.793 143.541 37.793C145.14 37.793 146.017 37.0795 146.558 36.2639H146.635V37.4617H148.904V31.4729C148.93 28.7206 146.842 27.1661 144.134 27.1661ZM143.85 35.7288C143.077 35.7288 141.994 35.3465 141.994 34.4036C141.994 33.2058 143.334 32.7216 144.495 32.7216C145.526 32.7216 146.017 32.951 146.661 33.2568C146.455 34.7094 145.217 35.7288 143.85 35.7288ZM157.233 27.4974L154.525 34.2762H154.448L151.637 27.4974H149.084L153.287 36.9521L150.89 42.2272H153.365L159.862 27.4974H157.233ZM135.96 37.5127H138.333V21.8909H135.96V37.5127Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9212 9.42893C13.5602 9.81116 13.3281 10.4228 13.3281 11.1873V38.8377C13.3281 39.6021 13.5345 40.2138 13.9212 40.5961L14.0244 40.6725L29.7012 25.1781V24.8213L14.0244 9.32697L13.9212 9.42893Z",
    fill: "url(#paint0_linear_5160_16702)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9135 30.3515L29.7051 25.1782V24.8214L34.9393 19.6481L35.0682 19.7246L41.2564 23.2159C43.0097 24.2098 43.0097 25.8408 41.2564 26.8347L35.0682 30.3005C35.0424 30.275 34.9135 30.3515 34.9135 30.3515Z",
    fill: "url(#paint1_linear_5160_16702)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0359 30.2754L29.6985 25.0001L13.9443 40.571C14.5374 41.1826 15.4914 41.259 16.5743 40.6474L35.0359 30.2754Z",
    fill: "url(#paint2_linear_5160_16702)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0313 19.7247L16.5441 9.35268C15.4611 8.74109 14.5071 8.81753 13.9141 9.42911L29.6682 25L35.0313 19.7247Z",
    fill: "url(#paint3_linear_5160_16702)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5160_16702",
    x1: 28.2954,
    y1: 39.1146,
    x2: 2.32484,
    y2: 12.5279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5160_16702",
    x1: 43.5207,
    y1: 25.0015,
    x2: 5.17746,
    y2: 25.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5160_16702",
    x1: 21.5694,
    y1: 32.5619,
    x2: -13.6488,
    y2: -3.49178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5160_16702",
    x1: -0.601758,
    y1: 39.3526,
    x2: 15.1248,
    y2: 23.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f23c3dcbde32e767203274d4b1749cc7.svg";
export { ForwardRef as ReactComponent };